import Swiper from "swiper";

class HomeSlider {
  constructor() {
    this.component = document.querySelector('[data-component="home-slider"]');
    this.trigger = document.querySelector('[data-trigger="home-slider"]');
    this._init();
  }

  _init() {
    if (this.component) {
      let swiper = null;

      swiper = new Swiper(this.trigger, {
        loop: true,
        navigation: {
          nextEl: ".home-slider__next",
          prevEl: ".home-slider__prev",
        },
      });
    }
  }
}

export const homeSlider = new HomeSlider();
